import type { RouteLocationRaw } from 'vue-router';

/** 顶栏页签稳定 key，避免 JSON.stringify 字段顺序不一致导致选中态错乱 */
export function pageTabRouteKey(to: RouteLocationRaw): string {
  if (typeof to === 'string') return to;
  const rec = to as { name?: string | symbol; params?: Record<string, unknown>; query?: Record<string, unknown> };
  const name = rec.name != null ? String(rec.name) : '';
  const params = rec.params ?? {};
  const query = rec.query ?? {};

  if (name === 'ProjectDashboard' || name === 'ProjectRequirements') {
    return `${name}:${String(params.id ?? '')}`;
  }
  if (name === 'ProjectCreate') {
    return `ProjectCreate:${String(query.draft ?? '')}`;
  }
  if (name === 'ProjectDocumentViewer') {
    return `ProjectDocumentViewer:${String(params.id ?? '')}:${String(params.objectKey ?? '')}`;
  }
  if (name === 'ProjectWbsSnapshot') {
    return `ProjectWbsSnapshot:${String(params.id ?? '')}`;
  }
  if (name === 'AiCalculatorDetail') {
    return `AiCalculatorDetail:${String(params.formulaId ?? '')}`;
  }
  if (name === 'AiSmartReview') return 'AiSmartReview';
  if (name === 'AiTools') return 'AiTools';
  if (name === 'AiRequirementLedger') return 'AiRequirementLedger';
  if (name === 'AiRequirementDetail') return `AiRequirementDetail:${String(params.id ?? '')}`;
  if (name === 'AiCalculator') return 'AiCalculator';
  if (name === 'Ai3DViewer') return 'Ai3DViewer';
  if (name === 'Dashboard') return 'Dashboard';
  if (name === 'KnowledgeSpace') return 'KnowledgeSpace';

  if (name) {
    const paramPart = stablePart(params);
    const queryPart = stablePart(query);
    if (paramPart || queryPart) {
      return `${name}?p=${paramPart}&q=${queryPart}`;
    }
    return name;
  }
  return stableStringify(to);
}

function stablePart(obj: Record<string, unknown>): string {
  const keys = Object.keys(obj).sort();
  if (!keys.length) return '';
  return keys.map((k) => `${k}=${String(obj[k] ?? '')}`).join('&');
}

function stableStringify(to: RouteLocationRaw): string {
  const rec = to as { name?: string | symbol; params?: Record<string, unknown>; query?: Record<string, unknown>; path?: string };
  return JSON.stringify({
    name: rec.name != null ? String(rec.name) : '',
    params: rec.params ?? {},
    query: rec.query ?? {},
    path: rec.path ?? '',
  });
}
